import React from 'react';

import ArrowIcon from '@material-ui/icons/PlayArrow';

import Icon from '@components/Icon/Icon';

import './TextWall.scss';

const TextWall = () => (
  <div className="text-wall">
    <div className="text-wall__row">
      <div className="text-wall__card">
        Let us remove the guesswork and <br />
        provide your company the information <br />
        it needs to select the <span className="text-wall__bold">optimal strategy</span> <br />
        and get the <span className="text-wall__bold">plan underway</span>.
      </div>
      <div className="text-wall__card text-wall__card--with-background">
        <div className="text-wall__card-title">
          Leading Consultants
        </div>
        <div className="text-wall__card-list">
          <div className="text-wall__card-list-item">
            <Icon className="text-wall__card-list-icon">
              <ArrowIcon />
            </Icon>
            <div className="text-wall__card-list-text">
              Restructuring
            </div>
          </div>
          <div className="text-wall__card-list-item">
            <Icon className="text-wall__card-list-icon">
              <ArrowIcon />
            </Icon>
            <div className="text-wall__card-list-text">
              Bankruptcy
            </div>
          </div>
          <div className="text-wall__card-list-item">
            <Icon className="text-wall__card-list-icon">
              <ArrowIcon />
            </Icon>
            <div className="text-wall__card-list-text">
              Class Action
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="text-wall__row">
      <div className="text-wall__card text-wall__card--with-background">
        <div className="text-wall__card-title">
          Bankruptcy Experts
        </div>
        <div className="text-wall__card-list">
          <div className="text-wall__card-list-item">
            <Icon className="text-wall__card-list-icon">
              <ArrowIcon />
            </Icon>
            <div className="text-wall__card-list-text">
              Comprehensive Case Administration
            </div>
          </div>
          <div className="text-wall__card-list-item">
            <Icon className="text-wall__card-list-icon">
              <ArrowIcon />
            </Icon>
            <div className="text-wall__card-list-text">
              Committee Services
            </div>
          </div>
        </div>
      </div>
      <div className="text-wall__card">
        Our <span className="text-wall__bold">senior team</span> has provided <br />
        administration and advisory services <br />
        to companies involved in some of <br />
        the <span className="text-wall__bold">most complex</span> bankruptcy cases.
      </div>
    </div>
    <div className="text-wall__row">
      <div className="text-wall__card">
        We are equipped to handle <br />
        the <span className="text-wall__bold">full suite</span> of legal administrative <br />
        services essential to a class action <br />
        lawsuit, <span className="text-wall__bold">from start to finish</span>.
      </div>
      <div className="text-wall__card text-wall__card--with-background">
        <div className="text-wall__card-title">
          Class Action Specialists
        </div>
        <div className="text-wall__card-list">
          <div className="text-wall__card-list-item">
            <Icon className="text-wall__card-list-icon">
              <ArrowIcon />
            </Icon>
            <div className="text-wall__card-list-text">
              Comprehensive Settlement Administration
            </div>
          </div>
          <div className="text-wall__card-list-item">
            <Icon className="text-wall__card-list-icon">
              <ArrowIcon />
            </Icon>
            <div className="text-wall__card-list-text">
              Class Action
            </div>
          </div>
          <div className="text-wall__card-list-item">
            <Icon className="text-wall__card-list-icon">
              <ArrowIcon />
            </Icon>
            <div className="text-wall__card-list-text">
              Mass Tort
            </div>
          </div>
          <div className="text-wall__card-list-item">
            <Icon className="text-wall__card-list-icon">
              <ArrowIcon />
            </Icon>
            <div className="text-wall__card-list-text">
              Claim Management
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default TextWall;



// WEBPACK FOOTER //
// ./src/routes/Landing/components/TextWall/TextWall.js